import { Tabs, withStyles } from '@material-ui/core';

export const TabsWithBlueIndicator = withStyles({
  indicator: {
    backgroundColor: '#5D66FA',
  },
})(Tabs);
